import { makeStyles, Theme } from "@material-ui/core";
import { getRelativeFontSize, regularFont } from "../../../utils/styles";

const customCreditCardStyles = makeStyles(
  (theme: Theme) => ({
    // container: {
    //   border: "1px solid #d9d9d9",
    //   padding: "4px",
    //   borderRadius: "8px",
    // },
    cardInputTitle: {
      ...regularFont,
      fontSize: getRelativeFontSize(0),
      marginLeft: "10px",
    },
    cardTypeImage: {
      width: "38px",
    },
    // input: {
    //   "& .MuiInputBase-input": {
    //     padding: "0px",
    //   },
    // },
    // zipCVCMM: {
    //   "& .MuiInputBase-input": {
    //     textAlign: "center",
    //   },
    // },
    // borderedBox: {
    //   border: "1px solid #eee",
    //   padding: "8px",
    // },
    customInput: {
      borderRadius: "8px",
      width: "100%",
      "& .MuiInputBase-input": {
        padding: "7px 4px",
      },
    },
    error: {
      color: "red",
    },
    errorMessage: {
      color: "red",
      fontSize: getRelativeFontSize(0),
      marginTop: "2px",
    },
    gridContainer: {
      "& .MuiGrid-item": {
        paddingTop: "8px",
        paddingLeft: "8px",
      },
      width: "100%",
      margin: "-8px 0 0 -8px !important",
    },
  }),
  { index: 1 }
);

export default customCreditCardStyles;
